import { addLocaleData, IntlProvider } from 'react-intl';
import localeDataEn from 'react-intl/locale-data/en';
// import localeDataFr from 'react-intl/locale-data/fr';
import en from './en';
// import fr from './fr';

addLocaleData([
  ...localeDataEn,
  // ...localeDataFr,
]);

export const { defaultLanguage } = process.env;

export const messages = {
  en: en.messages,
  // fr: fr.messages,
};

export const formatMessage = (locale, id) => {
  const intlProvider = new IntlProvider({ locale, messages: messages[locale] });
  const { intl } = intlProvider.getChildContext();
  return intl.formatMessage({ id });
};

export const supportedLanguages = Object.keys(messages);
